/* unplugin-vue-components disabled */import { render } from "./CustomerGender.vue?vue&type=template&id=1970644a&scoped=true"
import script from "./CustomerGender.vue?vue&type=script&lang=js"
export * from "./CustomerGender.vue?vue&type=script&lang=js"

import "./CustomerGender.vue?vue&type=style&index=0&id=1970644a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1970644a"]])

export default __exports__